// extracted by mini-css-extract-plugin
var _1 = "UploadImageDemo-modulepayload__FrC9V";
var _2 = "UploadImageDemo-modulepreview__S8xZn";
var _3 = "UploadImageDemo-moduleresult__M6wuA";
export { _1 as "payload", _2 as "preview", _3 as "result" }
